// extracted by mini-css-extract-plugin
module.exports = {"headingPrimary":"Heading_headingPrimary__3tU4K","headingSecondary":"Heading_headingSecondary__1Ha6d","heading":"Heading_heading__3L1fs","spin":"Heading_spin__3QqB0"};